export default __webpack_public_path__ + "static/media/Believer's Armbands of the Crumbling Tower.802a5f26.jpg";